import React from 'react'
import { Heading } from '@chakra-ui/react'

const AboutUs = () => {
  return (
    <div>
         <Heading as='h1' size='4xl'>About Us</Heading>
    </div>
  )
}

export default AboutUs